import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { normalizeLang } from "@/lib/i18n/lang-cookie";
import { useSettingsStore } from "@/store/settings";
import { getConfiguredUiStageId } from "@/utils/stage/stage-utils";

export function useStageBootstrap(isAuthReady: boolean) {
  const { i18n } = useTranslation();
  const language = i18n.language;
  const { beginBootstrap, loadStageContent, finishBootstrapError } =
    useSettingsStore();

  useEffect(() => {
    if (!isAuthReady) {
      return;
    }

    const uiStageId = getConfiguredUiStageId();

    const run = async () => {
      beginBootstrap();
      try {
        await loadStageContent(uiStageId, normalizeLang(language));
      } catch {
        finishBootstrapError();
      }
    };

    void run();
  }, [
    beginBootstrap,
    finishBootstrapError,
    isAuthReady,
    language,
    loadStageContent,
  ]);
}
